<app-dialog
  [title]="'Shipment'" 
  (close)="close()"
  (action)="action($event)" 
  [actions]="[
    { text: 'Close', buttonStyle: 'underline' },
    { text: btnText, isDisabled: disable || spin || (shipmentCreated && !shipmentCreatedWithError), spin: spin }
    ]" 
  >
  <p *ngIf="!loading && shipments.length" class="text-center font-bold my-3">
    This Shipment Includes {{ shipments.length }} Plans
  </p>
  <div class="plan-shipment-container" *ngIf="!loading && shipments.length">
    <ng-container *ngFor="let shipment of shipments; let i = index">
      <div class="plan-shipment-box selected" *ngIf="shipment.selected">
        <span class="sku_warning text-warning hand" *ngIf="!shipment.hasLockedSkus && withLockedSkus && data?.hasLockedSkus">
          <i class="far fa-exclamation-triangle me-1"></i>
          This shipment has no locked SKUs
         </span>
        <div class="plan-shipment-box_body">
          <mat-checkbox class="mat-checkbox-sm" [(ngModel)]="shipment.checked"
            (change)="checkValidation(true,i)"></mat-checkbox>
          <div class="star-cirle " [ngClass]="{'active':(data?.amazonShipmentId && data.isStarred) || data.shipmentId}">
            <i class="fas fa-star"></i>
          </div>
          <div class="col--12">
            <label>WH ID</label>
            <span>{{ shipment.destinationId }}</span>
          </div>
          <div class="col--28">
            <label>State</label>
            <span>{{ shipment.store }}</span>
          </div>
          <div class="col--12">
            <label>SKUs</label>
            <span>{{ shipment.sku | number}}</span>
          </div>
          <div class="col--12">           
            <label>Qty</label>
            <span>{{ shipment.qty | number}}</span>
          </div>
          <div class="col--12 cubic-field mt-1">           
            <label>Cubic Ft.</label>
            <span [matTooltip]="shipment.cubicFt">{{ shipment.cubicFt | number:'1.2-2' }}</span>
          </div>
          <div>
            <span *ngIf="shipment.hasLockedSkus" class="sku_lock text-primary hand" matTooltip="This shipment has locked skus">
              <i class="fal fa-lock active fas fa-lock" aria-hidden="true"></i>
            </span> 
          </div>
          <div class="mt-1">
            <label>Match</label>
            <span class="badge-stats" [ngClass]="{'badge-stats-gray': shipment.match < 85,'badge-stats-success': shipment.match >= 85 }">{{ round(shipment.match) }}</span>
          </div>
          <div>
            <div class="mt-2" *ngIf="!shipment.shipmentHeaderId">
              <label>Shipment Name</label>
              <input class="form-control form-control-sm data-input" type="text" [(ngModel)]="shipment.shipmentName"
                placeholder="(Optional)" (keypress)="restrictSpecialChar($event)" (change)="checkValidation()"
                required />
            </div>
            <div class="text-primary" *ngIf="shipment.shipmentHeaderId">
              <div class="shipment_title d-flex">
                <span class="shipment_name me-2 shipment_link" [routerLink]="['/shipyard/shipments/detail', shipment.shipmentHeaderId]">
                  {{shipment.shipmentId}}
                </span>
                <i class="fal icon text-primary" [ngClass]="{ 'fa-copy': !shipment?.copied, 'fa-check': shipment.copied }"
                [cdkCopyToClipboard]="shipment.shipmentId" (cdkCopyToClipboardCopied)="copy($event,shipment)">
              </i>
              </div>
            </div>
          </div>
        </div>

        <div *ngTemplateOutlet="commonTemplate; context: { $implicit: { i: i, shipment: shipment } }"></div>

      </div>
    </ng-container>
    <ng-container *ngIf="data.shipmentId">
      <app-page-container-devider [title]="shipments.length - 1 + ' Related Shipments'" [small]="true"
      class="my-4"></app-page-container-devider>
      <div class="d-flex justify-content-between align-items-center mb-2">
        <label class="px-2">
          <mat-checkbox class="mat-checkbox-sm me-2" [(ngModel)]="master_checked" (change)="setSelectAll($event)"></mat-checkbox>Select All</label>
          <app-button [buttonSize]="'action'" (click)="export()">Export All</app-button>
      </div>
    </ng-container>    
    <ng-container *ngFor="let shipment of shipments; let i = index">  
      <div class="plan-shipment-box" *ngIf="!shipment.selected">
        <div class="plan-shipment-box_header">
          <label (click)="$event.stopPropagation()"><mat-checkbox class="mat-checkbox-sm me-2"
              [(ngModel)]="shipment.checked" (change)="checkValidation(true,i)"></mat-checkbox>Shipment {{ i }}</label>
              <span class="sku_warning text-warning hand" *ngIf="!shipment.hasLockedSkus">
                <i class="far fa-exclamation-triangle me-1"></i>
                Locked Items Not in Shipment
              </span>
        </div>
        <div class="plan-shipment-box_body">
          <div class="star-cirle">
            <i class="fas fa-star"></i>
          </div>
          <div>
            <label>WH ID</label>
            <span>{{ shipment.destinationId }}</span>
          </div>
          <div>
            <label>State</label>
            <span>{{ shipment.store }}</span>
          </div>
          <div>
            <label>SKUs</label>
            <span>{{ shipment.sku | number}}</span>
          </div>
          <div>   
            <label>Qty</label>
            <span>{{ shipment.qty | number}}</span>
          </div>
          <div class="col--12 cubic-field mt-1">           
            <label>Cubic Ft.</label>
            <span class="cubic-value" [matTooltip]="shipment.cubicFt">{{ shipment.cubicFt | number:'1.2-2'}}</span>
          </div>
          <div>
            <span *ngIf="shipment.hasLockedSkus" class="sku_lock text-primary hand" matTooltip="This shipment has locked skus">
              <i class="fal fa-lock active fas fa-lock" aria-hidden="true"></i>
            </span>
          </div>
          <div class="col--last">
            <div class="mt-2" *ngIf="!shipment.shipmentHeaderId">
              <label>Shipment Name</label>
              <input class="form-control form-control-sm data-input" type="text" [(ngModel)]="shipment.shipmentName"
                placeholder="(Optional)" (keypress)="restrictSpecialChar($event)" (change)="checkValidation()"
                required />
            </div>
            <div class="text-primary" *ngIf="shipment.shipmentHeaderId">
              <div class="shipment_title d-flex">
                <span class="shipment_name me-2 shipment_link" [routerLink]="['/shipyard/shipments/detail', shipment.shipmentHeaderId]">
                  {{shipment.shipmentId}}
                </span>
                <i class="fal icon text-primary" [ngClass]="{ 'fa-copy': !shipment?.copied, 'fa-check': shipment.copied }"
                [cdkCopyToClipboard]="shipment.shipmentId" (cdkCopyToClipboardCopied)="copy($event,shipment)">
              </i>
              </div>
            </div>
          </div>
        </div>           

        <div *ngTemplateOutlet="commonTemplate; context: { $implicit: { i: i, shipment: shipment } }"></div>

      </div>
    </ng-container>
   <p class="notification-alert text-gray-11" *ngIf="selectedShipment?.length != shipments.length">
      <i class="fas fa-exclamation-triangle me-2"></i> Note: As per amazon policy, all corresponding proposals must be
      created and used.
    </p>
  </div>
  <div class="plan-shipment-container loader" *ngIf="loading">
    <img [src]="'assets/images/nineyard-loading.gif'" />
  </div>
</app-dialog>

<ng-template #commonTemplate let-data>
  <mat-accordion>
    <mat-expansion-panel [expanded]="data.shipment.expanded">
      <mat-expansion-panel-header>
        <a class="font_size_12">View Skus</a>
        <div class="feedback {{data.shipment.hasError ? 'error' : 'info'}}" *ngIf="data.shipment.errorMsg" [matTooltip]="data.shipment.errorMsg">{{data.shipment.errorMsg}}</div>  
        <div class="feedback success" *ngIf="!data.shipment.errorMsg && data.shipment.shipmentHeaderId">Shipment has been successfully created</div>
        <app-button *ngIf="data.shipment.hasError" class="retry-btn" [buttonSize]="'action'" [spin]="data.shipment.spin" [isDisabled]="data.shipment.spin || !data.shipment.checked || !data.shipment.shipmentName" (click)="retry(data.shipment,data.i)">
          Retry 
      </app-button> 
      </mat-expansion-panel-header>
      <div class="mt-2">


        <div class="column_filter d-flex">        
          <div class="round-input">
            <div class="round-input_searchIcon">
              <i class="fal fa-search"></i>
            </div>
            <input
              type="text"
              id="searchInp{{data.i}}"
              class="round-input_input round-input_search"
              [(ngModel)]="data.shipment.searchText"
              placeholder="Search"
              (keyup)="filterSkus(data.i)"
            />
            <div
              class="round-input_clear"
              *ngIf="data.shipment.searchText"
              (click)="filterSkus(data.i,true)"
            >
              <i class="fal fa-times"></i>
            </div>
          </div>
          <mat-slide-toggle
          class="mat-slide-toggle-sm"
            [labelPosition]="'before'"
            (change)="filterSkus(data.i)"
            [(ngModel)]="data.shipment.isOnlyLockedSkus">
            <span style="font-family: var(--font-primary)">Show Locked Item Only</span>
        </mat-slide-toggle>
        </div>
        <div class="sku-table">
          <div class="sku-table_header">
           <!-- <label *ngIf="!data.shipment.selected"><mat-checkbox class="mat-checkbox-sm me-3"></mat-checkbox></label>-->
            <div>SKUs</div>
            <div class="header-column">Qty</div>
          </div>
          <div class="sku-detail-view" *ngFor="let sku of data.shipment?.filteredSkus">
            <label><mat-checkbox class="mat-checkbox-sm me-2" [(ngModel)]="sku.checked" (change)="checkValidation(false,data.i)"></mat-checkbox></label>
            <div class="sku_image">
              <img [src]="sku.image" />
            </div>
            <div class="sku">
              <div class="sku_title">
                {{ sku.title }}
              </div>
              <div class="sku_chips font_size_12">
                <app-sku-chip [value]="sku.sku" [name]="'Sku'"></app-sku-chip>
                <app-sku-chip [value]="sku.asin" [name]="'Asin'"></app-sku-chip>
                <app-sku-chip [value]="sku.fnSku" [name]="'Fnsku'"></app-sku-chip>
              </div>
            </div>
            <div class="d-flex align-items-center ms-auto gap-3">
              <span class="sku_lock text-primary hand" matTooltip="Lock this item from rounding and only send the original amount" *ngIf="sku.isQtyLocked">
                <i class="fal fa-lock active fas fa-lock" aria-hidden="true"></i>
              </span> 
              <div class="skuqty">
                <span class="qty-box">{{ sku.qty | number}}</span>
              </div>
            </div>
          </div>
          <div class="record-null" *ngIf="!data.shipment?.filteredSkus.length">No Record Found</div>
        </div>
      </div>
    </mat-expansion-panel>
  </mat-accordion>
</ng-template>
